import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import useSearchList from '@/hooks/useSearchList';
import { SEARCH_ITEM_COL, TABLE_DATA_DEFAULT } from '@/scripts/config';
import { useGetUserPortQuery } from '@/store/apiSlice';
import { Button, message, Input, Card, Form, Select, Col, Row, Table } from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
const pageKey = 'MaerskList'; //页面身份
export default function MaerskList() {
    // const [dataSource, setData] = useState([]);
    const [submittingId, setSubmittingId] = useState(null);
    const [disableIds, setDisableIds] = useState([]);
    const { data: UserOptions } = useGetUserPortQuery();
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();

    // useEffect(() => {
    //     console.log(pageKey);
    // });

    //状态
    const orderStatusOptions = [
        { label: '未提交', value: 1 },
        { label: '已提交', value: 2 },
        { label: '已取消', value: 3 },
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
        },
        {
            title: '用户名',
            dataIndex: 'username',
            align: 'center',
        },
        {
            title: '起始港',
            dataIndex: 'origin',
            align: 'center',
        },
        {
            title: '目的港',
            dataIndex: 'destination',
            align: 'center',
        },
        {
            title: '小箱',
            dataIndex: 'twenty_feet',
            align: 'center',
            type: 'select',
        },
        {
            title: '平柜',
            dataIndex: 'forty_feet',
            align: 'center',
        },
        {
            title: '高箱',
            dataIndex: 'forty_feet_high_cube',
            align: 'center',
        },
        {
            title: '超高',
            dataIndex: 'forty_five_feet_high_cube',
            align: 'center',
        },
        {
            title: '开航时间',
            dataIndex: 'early_date',
            align: 'center',
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            align: 'center',
        },
        {
            title: '状态',
            dataIndex: 'type',
            width: 100,
            align: 'center',
            render: (value) => getLabelFromMap({ map: orderStatusOptions, value }),
        },
        {
            title: '操作',
            dataIndex: '',
            align: 'center',
            // render: (text, record, index) => <Button disabled={text.isDisabled} onClick={() => submit(text, record, index)} type="primary">提交</Button>,
            render: (data) => {
                if (data.type === 1) {
                    const disabled = disableIds.includes(data.id);
                    return (
                        <Button loading={data.id === submittingId} onClick={() => handleMaerskSubmit(data.id)} disabled={disabled}>
                            {disabled ? '提交完成' : '提交'}
                        </Button>
                    );
                }
                return null;
            },
        },
    ];

    // 提交
    const handleMaerskSubmit = async (id) => {
        setSubmittingId(id);
        const { type_status, data } = await ajax.post('locked/list', { id }, { rawResponse: true });
        setSubmittingId(null);
        message.info(data);
        if (type_status) setDisableIds([...disableIds, id]);
    };

    // 表格钩子
    const { renderSearchButton, renderTable } = useSearchList({
        pageKey,
        tableConfig: { columns, rowKey: 'id', dataKey: 'data', totalKey: 'total_page', pageSize: 20 },
        form,
        fetchDataFormat: (data) => {
            console.log(data);
            if (data) {
                return data.map((item) => {
                    item.update_time = dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss');
                    return item;
                });
            } else {
                return [];
            }
        },
    });

    return (
        <div className="list">
            <PageHeader title="Maersk Go列表" sticky></PageHeader>
            <Card className="ax-search-card">
                <Form form={form} className="formStyle" autoComplete="off">
                    <Row style={{ width: '60%' }}>
                        <Col span={4} {...SEARCH_ITEM_COL}>
                            <Form.Item label="订单状态" name="type">
                                <Select options={orderStatusOptions} allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={4} push={1} {...SEARCH_ITEM_COL}>
                            <Form.Item label="用户名" name="username">
                                <Select showSearch options={createJsonOptions(UserOptions)} allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={4} push={2}>
                            <Form.Item {...SEARCH_ITEM_COL}>{renderSearchButton()}</Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            {/* <Table dataSource={dataSource} columns={columns} rowKey={(record) => record.id}></Table> */}
            <Card className="ax-table-card">{renderTable()}</Card>
        </div>
    );
}
